<div class="card-body p-0">
    <div class="tabcasino">
        <tabset *ngIf="data">
            <tab [heading]="'1 To ' + tabDt.name" *ngFor="let tabDt of data.tables;trackBy:trackByIndex;">
<!--                <ng-template tabHeading>-->
<!--                    <img class="img-fluid" width="20" [src]="env.baseUrl + '/assets/casino_provider/' + tabDt.slug + '.png'">-->
<!--                    {{tabDt.name}}-->
<!--                </ng-template>-->

<!--                <div class="row py-2 mx-0 justify-content-center" >-->
<!--                    <div class="col-md-3 col-6 align-self-center text-center"-->
<!--                    *ngFor="let item of tabDt.data;trackBy:trackByIndex;">-->
<!--                        <div class="casino position-relative">-->
<!--                            &lt;!&ndash; <span>{{item.name}}</span> &ndash;&gt;-->
<!--                            <img class="img-fluid" [src]="item.image_path">-->
<!--                            <a href="javascript:void(0);" class="btn casino-btn" (click)="openModal(template, item, tabDt.name)">Play Now</a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
              <tabset >
                <tab *ngFor="let innerTabDt of tabDt.data;trackBy:trackByIndex;">

                  <ng-template tabHeading>
                    <!-- <img class="img-fluid" width="20" [src]="env.baseUrl + '/assets/casino_provider/' + innerTabDt.slug + '.png'"> -->
                    {{innerTabDt.name}}
                  </ng-template>

                  <div class="row mx-0 home_casinos_thumb" >
                    <div class="col-md-2 col-4 align-self-center text-center"  *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                      <div class="casino position-relative">
                        <!-- <span>{{item.name}}</span> -->
                        <img class="img-fluid" [lazyLoad]="item.image_path">
                        <a href="javascript:void(0);" class="btn casino-btn" (click)="openModal(template, item, tabDt.name)">Play Now</a>
                      </div>
                    </div>
                  </div>
                </tab>
              </tabset>

                <!-- <div class="owl-game">
                    <div class="owl-item row">
                        <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let item of tabDt.data;trackBy:trackByIndex;">
                            <a class="item items" href="javascript:void(0)"
                                (click)="openModal(template, item, tabDt.name)">
                                <img class="img-fluid" [src]="env.baseUrl + item.image_path">
                            </a>
                        </div>
                    </div>
                </div> -->
            </tab>
        </tabset>
    </div>
</div>
<app-loader class="no-overlay" *ngIf="!data"></app-loader>

<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title pull-left">{{gameName}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="iframeUrl != ''">
            <iframe scrolling="no" [src]="iframeUrl" allowfullscreen="true" title="game" id="casino-link"></iframe>
        </div>
    </div>
</ng-template>
